import React from 'react';
import '../styles/ContactsPage.css';

const CONTACTS = {
    fio: 'Макридин Евгений Романович',
    inn: '643922396500',
    email: 'admin@dogovor-builder.ru'
};

const ContactsPage = () => {
    return (
        <main className="contacts-page">
            <div className="contacts-page__container">
                <div className="contacts-page__content">
                    <div className="contacts-info-simple">
                        <p className="contact-main-line">Самозанятый {CONTACTS.fio}</p>
                        <div className="contact-details-row">
                            <span className="contact-label">ИНН:</span> {CONTACTS.inn}
                        </div>
                        <div className="contact-details-row">
                            <span className="contact-label">Email:</span> <a href={`mailto:${CONTACTS.email}`} className="contacts-link">{CONTACTS.email}</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ContactsPage;